import { SensorManagerPlugin, SensorManagerPluginPlugin } from "@WahooFitness/wsm-native";
import { PropsWithChildren, createContext } from "react";

export type IWsmPluginProps = {
  sensorManagerPlugin: SensorManagerPluginPlugin;
};

export const WsmContext = createContext<IWsmPluginProps | undefined>(undefined);

export const WsmContextProvider = ({ children }: PropsWithChildren) => {
  return (
    <WsmContext.Provider
      value={{
        sensorManagerPlugin: SensorManagerPlugin,
      }}
    >
      {children}
    </WsmContext.Provider>
  );
};
